module.exports = __webpack_public_path__ + "media/images/visio/tutorial-3-149d7798d9c0c2f1cd4148a58a247830.jpg";